import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Color from 'color'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { flexUtils, palette } from '../../Theme/Theme'
// import * as Actions from '../../Actions/Actions'
// import ReactGA from 'react-ga'
import Responsive from 'react-responsive'

const Desktop = props => <Responsive {...props} minWidth={736}/>
const Mobile = props => <Responsive {...props} maxWidth={735}/>

const mapStateToProps = state => {
  return {
  }
}

class HomeFooter extends Component {
  render () {
    const { classes } = this.props
    return (
      <div>
        <Desktop>
          <div className={classes.Footer}>
            <span className={classes.FooterGroup}>
              <a className={classes.IconLink} rel="noopener noreferrer" href="https://www.facebook.com/spectivinc/" target='_blank'>
                <span className={classes.IconLink}><i className="fa-fw fab fa-facebook-square"/></span>
              </a>
              <a className={classes.IconLink} rel="noopener noreferrer" href="https://twitter.com/spectivmedia" target='_blank'>
                <span className={classes.IconLink}><i className="fa-fw fab fa-twitter-square"/></span>
              </a>
              <a className={classes.IconLink} rel="noopener noreferrer" href="https://www.instagram.com/spectiv/" target='_blank'>
                <span className={classes.IconLink}><i className="fa-fw fab fa-instagram"/></span>
              </a>

              <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
              <a className={classes.IconLink} rel="noopener noreferrer" target='_blank' href="https://channelstore.roku.com/details/154913/spectiv">
                <span style={{fontWeight: '700'}}>R<span style={{fontSize: '1.2rem'}}>OKU</span></span>
              </a>
              <a className={classes.IconLink} href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
                <span className={classes.IconLink}><i className="fa-fw fab fa-apple"/></span>
              </a>
              <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
              <a className={classes.IconLink} rel="noopener noreferrer" href="https://www.spectiv.co" target='_blank'>
                <span className={classes.IconLink} style={{fontSize: '1.2rem'}}>Learn More</span>
              </a>
              <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
              <a className={classes.IconLink} rel="noopener noreferrer" href="https://spectiv.co/Engage/Contact" target='_blank'>
                <span className={classes.IconLink} style={{fontSize: '1.2rem'}}>Contact Us</span>
              </a>
            </span>
          </div>
        </Desktop>
        <Mobile>
          <div className={classes.Footer} style={{width: '100vw'}}>
            <span className={classes.FooterGroup} style={{justifyContent: 'space-around'}}>
              <a className={classes.IconLinkMobile} rel="noopener noreferrer" href="https://www.facebook.com/spectivinc/" target='_blank'>
                <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-facebook-square"/></span>
              </a>
              <a className={classes.IconLinkMobile} rel="noopener noreferrer" href="https://twitter.com/spectivmedia" target='_blank'>
                <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-twitter-square"/></span>
              </a>
              <a className={classes.IconLinkMobile} rel="noopener noreferrer" href="https://www.instagram.com/spectiv/" target='_blank'>
                <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-instagram"/></span>
              </a>

              <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
              <a className={classes.IconLinkMobile} rel="noopener noreferrer" target='_blank' href="https://channelstore.roku.com/details/154913/spectiv">
                <span style={{fontWeight: '700'}}>R<span style={{fontSize: '1.2rem'}}>OKU</span></span>
              </a>
              <a className={classes.IconLinkMobile} href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
                <span className={classes.IconLinkMobile}><i className="fa-fw fab fa-apple"/></span>
              </a>
              <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
              <a className={classes.IconLinkMobile} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}} rel="noopener noreferrer" href="https://www.spectiv.co" target='_blank'>
                <span className={classes.IconLinkMobile} style={{fontSize: '1rem', alignItems: 'center'}}>Learn</span><span className={classes.IconLinkMobile} style={{fontSize: '1rem', alignItems: 'center'}}>More</span>
              </a>
              <div style={{width: '1px', height: '1.5rem', margin: '0 .5rem', background: 'rgb(70, 70, 70)', display: 'inline-block'}}/>
              <a className={classes.IconLinkMobile} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}} rel="noopener noreferrer" href="https://spectiv.co/Engage/Contact" target='_blank'>
                <span className={classes.IconLinkMobile} style={{fontSize: '1rem', alignItems: 'center'}}>Contact</span><span className={classes.IconLinkMobile} style={{fontSize: '1rem', alignItems: 'center'}}>Us</span>
              </a>
            </span>
          </div>
        </Mobile>
      </div>
    )
  }
}

const styles = {
  ...flexUtils,
  Body: {
    composes: ['$FlexColumn'],
    justifyContent: 'space-between',
    flex: '1',
    height: '100%',
    minHeight: '80vh',
    width: '100%',
    maxWidth: '40rem'
  },
  Label: {
    color: `${Color(palette.blue).lighten(0.5)}`,
    fontWeight: '400',
    marginTop: '2rem',
    padding: '1rem 0rem',
    fontSize: '1rem',
    textAlign: 'center',
    width: '100%',
    borderBottom: '1px solid rgb(200, 200, 200)'
  },
  InfoItem: {
    composes: ['$FlexRow'],
    fontSize: '1rem',
    justifyContent: 'space-between',
    color: palette.white,
    width: '100%',
    padding: '1rem 1rem 1rem 1rem',
    fontWeight: '400'
  },
  InfoItemMobile: {
    extend: 'InfoItem'
  },
  EditButton: {
    color: palette.lightFont,
    fontWeight: '200',
    transition: 'color .5s',
    marginLeft: '1rem',
    '&:hover': {
      color: palette.orange,
      cursor: 'pointer'
    }
  },
  UnsubscribeButton: {
    composes: ['$EditButton'],
    color: 'rgb(120, 120, 120)'
  },
  ExternalLink: {
    color: palette.blue,
    textDecoration: 'none',
    transition: 'color .5s',
    '&:hover': {
      color: `${Color(palette.blue).lighten(1)}`
    }
  },
  Footer: {
    height: '3rem',
    display: 'flex',
    borderRadius: '5px 5px 0 0',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'rgba(22, 22, 22, 0.3)'    
  },
  FooterGroup: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem'
  },
  IconLink: {
    textDecoration: 'none',
    fontSize: '1.5rem',
    color: 'rgb(160, 160, 160)',
    transition: 'color .5s',
    margin: '0rem .3rem',
    '&:hover': {
      color: palette.blue
    }
  },
  IconLinkMobile: {
    textDecoration: 'none',
    fontSize: '1.5rem',
    fontWeight: '100',
    color: 'rgb(160, 160, 160)',
    transition: 'color .5s',
    // margin: '0rem .1rem',
    '&:hover': {
      color: palette.blue
    }
  },
  Link: {
    composes: '$IconLink',
    fontSize: '1rem',
    textDecoration: 'none'
  }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(HomeFooter)))



// WEBPACK FOOTER //
// ./src/js/Components/Home/HomeFooter.jsx